import AppLogisticVariant from "./logisticVariant/logisticVariant.vue";
import store from "@/app/app-state";
import PrivateLayout from "@/app/layouts/Private.vue";

const stockRoutes = [
  {
    path: "/logisticVariant",
    meta: {
      type: "module",
      breadcrumb: [
        {
          text: "LogisticVariant"
        }
      ],
      iconClass: "mdi-truck-delivery"
    },
    component: PrivateLayout,

    children: [
      {
        path: "logisticVariant",
        component: AppLogisticVariant,
        meta: {
          breadcrumb: [
            {
              text: "logisticVariant",
              to: "/logisticVariant/logisticVariant"
            }
          ],
          //TODO : placer les bon droit d'acces pour ce module
          rightName: "_STOCK_STREAMTYPEMOVEMENTCODE", // droit créé sour Tesfri (rightManager)
          type: "subModule",
          iconClass: "mdi-transit-detour"
        },

        beforeEnter: (to, _from, next) => {
          if (store.state.userContext.rights.includes(to.meta.rightName)) {
            next();
          } else {
            const redirectUri = to.fullPath;
            store.dispatch("userContext/logout").then(next({ name: "login", query: { redirectUri: redirectUri } }));
          }
        }
      }
    ]
  }
];

export default stockRoutes;
